import type { McpClient } from '@/types/mcp'
import { pickString } from './coercion'

export function toMcpClient(raw: unknown): McpClient {
  const record = raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {}
  return {
    clientId: pickString(record['clientId']),
    name: pickString(record['name']),
  }
}
